export const UpdateEntitygeometryByFulluid = `
    mutation ($fullUid: String!, $patchObject: EntitygeometryPatch!) {
        updateEntitygeometryByFullUid (input: {
            fullUid: $fullUid,
            entitygeometryPatch: $patchObject
        }) {
            entitygeometry {
                objectid
                fid2
                geoType
                type
                fullUid
                theGeom
            }
        }
    }
`;
